import { render, staticRenderFns } from "./CaratulaExpediente.vue?vue&type=template&id=5336a983&scoped=true&"
import script from "./CaratulaExpediente.vue?vue&type=script&lang=js&"
export * from "./CaratulaExpediente.vue?vue&type=script&lang=js&"
import style0 from "./CaratulaExpediente.vue?vue&type=style&index=0&id=5336a983&prod&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5336a983",
  null
  
)

export default component.exports